const steps = [
  {
    id: "01",
    title: "STORYLINE",
    body:
      "A cinematic narrative — spies, factions, moles, protectors. Players don't attend a workshop. They enter a world.",
    log: "> narrative_engine.init()",
  },
  {
    id: "02",
    title: "PRESSURE",
    body:
      "Real-time constraints. Competing teams. Deception. Consequential choices. The mask slips.",
    log: "> pressure.escalate(pilot=true)",
  },
  {
    id: "03",
    title: "DEBRIEF",
    body:
      "CSSDPH framework surfaces the actual decision patterns. Leadership gets a report — not vibes.",
    log: "> debrief.export(format='pdf')",
  },
];

const ENGINE_IMG =
  "https://images.unsplash.com/photo-1563206767-5b18f218e8de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxoYWNrZXIlMjB0ZXJtaW5hbCUyMGRhcmslMjBzY3JlZW58ZW58MHx8fHwxNzgyODg3NTA4fDA&ixlib=rb-4.1.0&q=85";

export default function Engine() {
  return (
    <section
      id="engine"
      data-testid="engine-section"
      className="relative py-28 lg:py-36 border-b border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-20">
        <img
          src={ENGINE_IMG}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/80 to-[#050505]" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 lg:col-span-6">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#dc2626] mb-4 flex items-center gap-3">
              <span className="w-8 h-px bg-[#dc2626]" /> 04 · The Engine
            </div>
            <h2 className="font-display uppercase font-black text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              Story <span className="text-neutral-500">→</span> Pressure
              <br />
              <span className="text-neutral-500">→</span> Debrief.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-6 lg:pt-8">
            <p className="text-neutral-400 leading-relaxed max-w-lg">
              Every Lunipin format runs on the same underlying engine. Change the skin,
              change the domain, keep the diagnostic power. It&apos;s how one framework
              produces measurable outputs across cyber, decision, information, risk,
              intelligence and trust.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <div
              key={s.id}
              data-testid={`engine-step-${i}`}
              className="relative bg-[#0a0a0a]/80 backdrop-blur-sm border border-white/10 p-8 min-h-[280px] flex flex-col justify-between hover:border-[#dc2626]/60 transition-colors"
            >
              <div>
                <div className="flex items-center gap-4 mb-6">
                  <span className="font-display font-black text-6xl text-[#dc2626] leading-none">
                    {s.id}
                  </span>
                  <div className="flex-1 border-t border-white/10" />
                </div>
                <h3 className="font-display uppercase font-black text-2xl tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-4 text-neutral-400 leading-relaxed">{s.body}</p>
              </div>
              <div className="mt-6 font-mono text-[11px] text-[#f59e0b] bg-black/60 border border-white/5 p-3">
                {s.log}
              </div>
            </div>
          ))}
        </div>

        {/* CSSDPH framework strip */}
        <div className="mt-12 border border-white/10 bg-black/60 p-6 flex flex-wrap items-center justify-between gap-6">
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
            CSSDPH FRAMEWORK · signals extracted per session
          </div>
          <div className="flex flex-wrap gap-2">
            {["Clarity", "Signal", "Speed", "Decision", "Pressure", "Human"].map((k, i) => (
              <span
                key={i}
                className="font-mono text-[10px] uppercase tracking-[0.2em] text-white border border-white/15 bg-white/[0.02] px-3 py-1.5"
              >
                {k[0]} · {k}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
